import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DownloadDashboardViewPDFRPC } from "./downloadDashboardViewPdfRPC";

export class DownloadDashboardViewPDFRPCClientImpl extends DownloadDashboardViewPDFRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DownloadDashboardViewPDFRPC.Request): Promise<LeoRPCResult<DownloadDashboardViewPDFRPC.Response, DownloadDashboardViewPDFRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/DownloadDashboardViewPDF",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DownloadDashboardViewPDFRPC.ResponseDTO,
      DownloadDashboardViewPDFRPC.Errors.ErrorsDTO,
      DownloadDashboardViewPDFRPC.Response,
      DownloadDashboardViewPDFRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/DownloadDashboardViewPDF",
      DownloadDashboardViewPDFRPC.Response.fromDTO,
      DownloadDashboardViewPDFRPC.Errors.fromDTO
    );
  }
}
